<template>
  <am-menu-anchor class="am-hint-anchor">
    <div class="am-hint-icon" @click="showHint">
      <!-- @slot Hint Icon -->
      <slot />
    </div>
    <am-menu
      class="am-hint-surface"
      :anchorCorner="anchorCorner"
      defaultFocusState="NONE"
      v-model="isShown"
      :isHoisted="isHoisted"
      :fixed="fixed"
    >
      <am-typography variant="body2">
        <!-- @slot Hint Text -->
        <slot name="text" />
      </am-typography>
    </am-menu>
  </am-menu-anchor>
</template>

<script>
import { AmMenu, AmMenuAnchor } from "../Menu";
import { AmTypography } from "../Typography";
import { enumValidator } from "../enumValidator";

export default {
  inheritAttrs: false,
  data() {
    return {
      isShown: false
    };
  },
  components: {
    AmMenu,
    AmMenuAnchor,
    AmTypography
  },
  props: {
    /**
     * [
     "TOP_RIGHT",
     "TOP_END",
     "BOTTOM_START",
     "BOTTOM_END",
     "BOTTOM_LEFT",
     "BOTTOM_RIGHT",
     ]
     */
    anchorCorner: {
      type: String,
      validator: enumValidator(["TOP_RIGHT", "TOP_END", "BOTTOM_START", "BOTTOM_END", "BOTTOM_LEFT", "BOTTOM_RIGHT"]),
      default: "BOTTOM_START"
    },
    /**
     * Sets whether the menu surface has been hoisted to the body
     * so that the offsets are calculated relative to the page
     * and not the anchor.
     */
    isHoisted: {
      type: Boolean,
      default: false
    },
    /**
     * Sets menu surface to fixed position relative to element.
     */
    fixed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showHint() {
      this.isShown = true;
    }
  }
};
</script>
<style lang="scss">
.am-hint-anchor {
  display: inline-block;

  .am-hint-surface {
    margin: 10px;
    padding: 16px;
    width: 412px;
    background-color: #f6f9fe;
    border-radius: 4px;
    max-height: initial !important;
    box-shadow: 0 1px 10px 0 rgba(85, 85, 85, 0.06), 0 4px 5px 0 rgba(85, 85, 85, 0.08),
      0 2px 4px 0 rgba(85, 85, 85, 0.1);
  }
}
.am-hint-icon {
  cursor: pointer;
}
</style>
